export default __webpack_public_path__ + "static/media/Food.77cdc593.svg";